import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import InternshipDetails from "../../components/internshipDetails/internship";
import { getInternshipsDetails } from "../../services/internships";

function InternshipDetailsPage() {
  const internshipID = window.location.pathname.split("/")[2];
  const [loader, setLoader] = useState(true);
  const [internshipData, setInternshipData] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
    internshipsDetails();
  }, []);

  async function internshipsDetails() {
    await getInternshipsDetails(internshipID)
      .then((response) => {
        if (response.data === null) {
          setLoader(false);
          return;
        }
        setInternshipData(response.data);
        setLoader(false);
      })
      .catch((error) => console.log(error));
  }

  return (
    <Box>
      {loader ? (
        ""
      ) : !internshipData ? (
        <Typography
          sx={{ fontSize: "40px", height: 150, textAlign: "center", pt: 11 }}
        >
          Internship Not Found
        </Typography>
      ) : (
        <InternshipDetails internshipData={internshipData} />
      )}
    </Box>
  );
}

export default InternshipDetailsPage;
